module.exports = __webpack_public_path__ + "img/6.424da570.png";